import { Connector } from '../../backendConnector';


export const INSURANCE_TYPE = {
  NONE: 'AUCUNE',
  CLASSIC: 'CLASSIQUE',
  COMPLEMENTARY: 'COMPLEMENTAIRE',
};

export const FLEXIBLE_DATE = 0;
export const FIX_DATE = 1;
export const UNKNOWN_DATE = 2;

function isValidDate(state) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    (
      state.dates[0]
      && (
        state.dates[0].chosen_by_client === FLEXIBLE_DATE
        || state.dates[0].chosen_by_client === UNKNOWN_DATE
      )
    )
      && state.dates[0].date_first
      && new Date(state.dates[0].date_first) >= today
      && state.dates[0].date_last
  ) || (
    state.dates[0]
    && state.dates[0].chosen_by_client === FIX_DATE
    && state.dates[0].date_first
    && new Date(state.dates[0].date_first) >= today
  );
}

function isValidServices(state) {
  return state.serviceOffer.cartons !== null
    && state.serviceOffer.wardrobes !== null
    && state.serviceOffer.mount !== null
    && state.serviceOffer.fragile !== null
    && state.serviceOffer.unbreakable !== null;
}

function isValidInsurance(state) {
  return state.insurance.type !== null && state.insurance.value > 0;
}

const state = {
  predefinedFormules: [],
  predefinedFormulesLoading: false,
  predefinedServices: [],
  predefinedServicesLoading: false,
  predefinedAssurances: [],
  predefinedAssurancesLoading: false,
  serviceOffer: {
    cartons: null,
    wardrobes: null,
    mount: null,
    fragile: null,
    unbreakable: null,
  },
  insurance: {
    type: '',
    value: 0,
  },
  dates: [],
  serviceOfferLoading: false,
};

const actions = {
  datesSaveState({
    commit,
    getters,
  }) {
    commit('SET_SERVICE_OFFER_LOADING');
    return Connector.getInstance()
      .postDates(getters.dates)
      .then(() => {
        commit('UNSET_SERVICE_OFFER_LOADING');
      })
      .catch((error) => {
        throw new Error(error);
      });
  },
  servicesSaveState({
    commit,
    getters,
  }) {
    commit('SET_SERVICE_OFFER_LOADING');
    Connector.getInstance().postServices(getters.serviceOffer)
      .then(() => {
        commit('UNSET_SERVICE_OFFER_LOADING');
      }).catch((error) => {
        throw new Error(error);
      });
  },
  assuranceSaveState({
    commit,
    getters,
  }) {
    commit('SET_SERVICE_OFFER_LOADING');
    return Connector.getInstance().postInsurance({
      assurance: getters.insurance.type,
      assurance_value: getters.insurance.value,
    });
  },
};

const getters = {
  serviceOffer: state => state.serviceOffer,
  dates: state => state.dates,
  insurance: state => state.insurance,
  cartons: state => state.serviceOffer.cartons,
  mount: state => state.serviceOffer.mount,
  wardrobes: states => states.serviceOffer.wardrobes,
  unbreakable: state => state.serviceOffer.unbreakable,
  fragile: state => state.serviceOffer.fragile,
  'insurance/value': state => state.insurance.value,
  'insurance/type': state => state.insurance.type,
  'dates/isValidForm': isValidDate,
  'services/isValidForm': isValidServices,
  'assurance/isValidForm': isValidInsurance,
};

const mutations = {
  SET_CARTONS(state, value) {
    state.serviceOffer.cartons = value;
  },
  SET_WARDROBES(state, value) {
    state.serviceOffer.wardrobes = value;
  },
  SET_MOUNT(state, value) {
    state.serviceOffer.mount = value;
  },
  SET_FRAGILE(state, value) {
    state.serviceOffer.fragile = value;
  },
  SET_UNBREAKABLE(state, value) {
    state.serviceOffer.unbreakable = value;
  },
  SET_SERVICES_OFFER(state, {
    cartons, fragile, mount, unbreakable, wardrobes,
  }) {
    state.serviceOffer = {
      cartons,
      fragile,
      mount,
      unbreakable,
      wardrobes,
    };
  },
  SET_INSURANCE(state, { assurance_value, assurance }) {
    state.insurance.value = assurance_value;
    state.insurance.type = assurance;
  },
  SET_INSURANCE_VALUE(state, value) {
    state.insurance.value = value;
  },
  SET_INSURANCE_TYPE(state, type) {
    state.insurance.type = type;
  },
  SET_DATES(state, dates) {
    state.dates = dates;
  },
  SET_SERVICE_OFFER_LOADING(state) {
    state.serviceOfferLoading = true;
  },
  UNSET_SERVICE_OFFER_LOADING(state) {
    state.serviceOfferLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
